// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9d282e38","879":"677943f3"}[chunkId] + ".chunk.js";
};